import { render } from "./AltaOk.vue?vue&type=template&id=35ab4657&scoped=true"
import script from "./AltaOk.vue?vue&type=script&lang=js"
export * from "./AltaOk.vue?vue&type=script&lang=js"

import "./AltaOk.vue?vue&type=style&index=0&id=35ab4657&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-35ab4657"

export default script